import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var RefStack = function RefStack() {
  var _this = this;

  _classCallCheck(this, RefStack);

  _defineProperty(this, "set", new Set());

  _defineProperty(this, "getContextRefs", function (ref) {
    var nodes = Array.from(_this.set);
    var refId = nodes.indexOf(ref);
    return nodes.slice(refId);
  });

  _defineProperty(this, "register", function (ref) {
    _this.set.add(ref);
  });

  _defineProperty(this, "unregister", function (ref) {
    _this.set["delete"](ref);
  });
};

export { RefStack as default };